module.exports = __webpack_public_path__ + "img/sex_on_the_beach.23019ca7.jpg";